import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown } from 'lucide-react';
import { ArrivalsIcon } from '../../../components/icons';
import { floatingSurfaceClass } from '../floatingSurfaceStyles';

const SURFACE = floatingSurfaceClass(97);

/** The pill's width, exported so the panel it opens can't drift narrower. */
export const ARRIVALS_WIDTH = 'w-[300px]';

/**
 * Collapsed arrivals summary — the desktop replacement for ScorecardsBar's
 * full-width bar. Floats on the map, so it carries the same translucent,
 * blurred surface as the layer rail and the filter pills.
 *
 * Presentational: the caller owns the window, the unit and what the chevron
 * opens.
 */
const MapArrivalsStrip = ({ value, unitLabel, days = 7, open = false, onToggle, className = '' }) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={onToggle}
      aria-expanded={open}
      // Content width on phones, fixed from lg. The 300px exists so the open
      // panel cannot be wider than the pill it hangs off on desktop; on a
      // phone it just padded "Arrivals 19,868,112 kg · 10d" out to the far
      // side of the screen.
      className={`flex h-[40px] w-fit max-w-full shrink-0 cursor-pointer items-center gap-[8px] rounded-[20px] border border-solid py-0 pl-[13px] pr-[6px] lg:w-[300px] ${SURFACE} ${className}`}
    >
      <ArrivalsIcon className="h-[16px] w-[16px] shrink-0 text-[#16A34A] dark:text-[#22C55E]" />
      <span className="font-['Inter'] text-[13px] font-bold whitespace-nowrap text-[#343440] dark:text-[#E6E8E6]">
        {t('map.arrivals.title', 'Arrivals')}
      </span>
      <span className="font-['Inter'] text-[13px] font-extrabold whitespace-nowrap text-[#16A34A] dark:text-[#22C55E]">
        {value}
      </span>
      <span className="font-['Inter'] text-[11.5px] font-semibold whitespace-nowrap text-[#828382]">
        {unitLabel} · {days}d
      </span>
      <span className="ml-auto flex h-[28px] w-[28px] shrink-0 items-center justify-center rounded-full bg-[#F3F5F2] dark:bg-[#252B27]">
        <ChevronDown
          size={13}
          className={`text-[#5D625F] transition-transform dark:text-[#9AA09A] ${open ? 'rotate-180' : ''}`}
        />
      </span>
    </button>
  );
};

export default MapArrivalsStrip;
